import React from 'react';
import lampstand from '../../../assets/image/lampstand.png';
import lampstandLight from '../assets/lampstandlight.png';
import styles from '../screen.module.scss';
import { Themes, useTheme } from '@maxtropy/components';

type LampImageProps = {
  headImageUrl: string;
};

export default function LampImage({ headImageUrl }: LampImageProps) {
  const theme = useTheme();

  return (
    <div className={styles.lampImage} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <img
        style={{ objectFit: 'cover', marginBottom: '-48px', display: 'inline-block' }}
        width="48"
        src={headImageUrl}
        alt=""
      />
      <img
        style={{ objectFit: 'cover', display: 'inline-block' }}
        width="100"
        src={theme === Themes.DARK ? lampstand : lampstandLight}
        alt=""
      />
    </div>
  );
}
